<a [routerLink]="configuration.url" class="flex justify-center min-h-72 max-h-72  flex-col bg-white rounded-xl border-2 border-gray-light p-6 gap-y-1 hover:shadow-md duration-200">
    <div [innerHTML]="safeIconHtml" class="text-gray flex justify-center"></div>
    <h1 class="text-xl text-dark text-center">{{configuration.name}}</h1>
    <p class="text-sm text-dark text-center">{{configuration.info}}</p>
<!--     <a [routerLink]="configuration.url" class="border-2 rounded-xl duration-300 hover:bg-border hover:text-white font-medium w-fit text-dark py-2 px-8 mx-auto border-gray-light mt-6">Configurar</a>
 --></a>
